import styled from 'styled-components';
import {device} from '../../styled/device';

export const EmptyScreen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 285px;
  margin: 30px auto 0;

  & > img {
    margin-bottom: 24px;
  }

  & > h1 {
    margin: 0 0 8px 0;
    padding: 0;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }

  & > p {
    font-size: 14px;
    font-weight: 400;
    padding: 0;
    margin: 0;
    text-align: center;
  }

  @media (min-width: ${device.laptop}) {
    margin-top: 8px;

    & > img {
      margin-bottom: 32px;
    }

    & > h1 {
      margin: 0 0 13px 0;
    }
  }
`;
